import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import React from "react";
import "./Competitions.css";
import { Images } from "../../../../helpers/Images";
import { useNavigate } from "react-router-dom";

const CompetitionsSection = () => {
  const navigate = useNavigate();

  const competitions = [
    {
      id: "robo-boom",
      title: "RoboBoom",
      description:
        "RoboBoom is an exciting robotics competition where participants aged 6-10 years old design and build robots to compete in dynamic challenges, showcasing their engineering and programming skills.",
      image: Images.roboBoom,
      link: "/competition/robo-boom",
    },
    {
      id: "rc-code",
      title: "RC Code",
      description:
        "RC Code is an innovative programming competition that challenges participants to develop creative coding solutions, fostering problem-solving skills and computational thinking through engaging challenges.",
      image: Images.rccode,
      link: "/competition/rc-code",
    },
  ];

  return (
    <Box
      className="competitions-section"
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px 20px 20px",
          sm: "50px 60px",
          lg: "70px 120px",
        },
        backgroundColor: "#f8f9fa",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h2"
          className="competitions-title"
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "42px" },
            fontWeight: "700",
            color: "primary.darker",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          New Categories
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "120px", md: "180px" },
            background:
              "linear-gradient(90deg, transparent, #830d0b, transparent)",
            margin: "0 auto 30px auto",
            borderRadius: "2px",
            // boxShadow: "0 2px 8px rgba(131, 13, 11, 0.3)",
          }}
        />

        <Grid
          container
          spacing={{ xs: 2, md: 6 }}
          sx={{
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {competitions.map((competition, index) => (
            <Grid item xs={12} md={6} key={competition.id}>
              <Card
                className="competition-card"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "24px",
                  overflow: "hidden",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: "1px solid rgba(131, 13, 11, 0.1)",
                  backgroundColor: "secondary.main",
                  "&:hover": {
                    transform: "translateY(-12px)",
                    boxShadow: "0 16px 48px rgba(131, 13, 11, 0.2)",
                    borderColor: "primary.main",
                  },
                }}
              >
                <Box
                  className="competition-image-wrapper"
                  sx={{
                    width: "100%",
                    height: { xs: "180px", sm: "220px" },
                    overflow: "hidden",
                    position: "relative",
                    backgroundColor: "#f0f0f0",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 100%)",
                      pointerEvents: "none",
                    },
                  }}
                >
                  <img
                    src={competition.image}
                    alt={competition.title}
                    className="competition-image"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                  />
                </Box>
                <CardContent
                  sx={{
                    padding: "24px",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { xs: "24px", sm: "28px" },
                        fontWeight: "700",
                        color: "primary.darker",
                        marginBottom: "10px",
                        textAlign: "center",
                        letterSpacing: "-0.3px",
                      }}
                    >
                      {competition.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: "15px", sm: "16px" },
                        color: "rgba(0, 0, 0, 0.7)",
                        lineHeight: 1.4,
                        textAlign: "center",
                        marginBottom: "20px",
                      }}
                    >
                      {competition.description}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      className="competition-button"
                      onClick={() => navigate(competition.link)}
                      sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        padding: { xs: "12px 32px" },
                        fontWeight: "600",
                        backgroundColor: "primary.main",
                        color: "secondary.main",
                        borderRadius: "30px",
                        textTransform: "none",
                        letterSpacing: "0.5px",
                        boxShadow: "0 4px 16px rgba(131, 13, 11, 0.3)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        marginBottom: "5px",
                        "&:hover": {
                          backgroundColor: "primary.light",
                          transform: "translateY(-2px)",
                          boxShadow: "0 6px 24px rgba(131, 13, 11, 0.4)",
                        },
                        "&:active": {
                          transform: "translateY(0) scale(1.02)",
                        },
                      }}
                    >
                      Learn More About {competition.title}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CompetitionsSection;
